module.exports = __webpack_public_path__ + "media/images/carrusel/moviles-45686c56a30d4f817b4a0e777236cbfc.jpg";